(function($) {
    $(document).ready(function() {
        //Filter Logik für Event Filterungen
        function applyAllFilters() {
            // 1. Sammle alle Select-Filterwerte
            const selectedValues = [];
            $('.filterselect').each(function() {
                if($(this).val() !== '*') {
                    selectedValues.push($(this).val());
                }
            });

            // 2. Hole den Suchtext
            const searchText = $('#searchFilter').val().toLowerCase().trim();

            // 3. Bestimme die anzuzeigenden Elemente
            let $allItems = $('.event-item');
            let $itemsToShow = $allItems;

            // Wende die Select-Filter an (wenn vorhanden)
            if (selectedValues.length > 0) {
                let selector = '.event-item';
                selectedValues.forEach(function(value) {
                    selector += value;
                });
                $itemsToShow = $(selector);
            }

            // Wende den Textfilter an (wenn vorhanden)
            if (searchText !== '') {
                $itemsToShow = $itemsToShow.filter(function() {
                    const title = $(this).find('.event-title').text().toLowerCase();
                    return title.includes(searchText);
                });
            }

            // 4. Führe die Animationen durch
            let $itemsToHide = $allItems.not($itemsToShow);
            $itemsToHide.fadeOut(400);
            $itemsToShow.fadeIn(400);
        }

        // Event-Handler für Filter-Select-Boxen
        // Nur wenn NICHT im Eventcalendar Block (der hat eigene Filterlogik)
        $('.filterselect').on('change', function() {
            // Prüfe ob wir im Eventcalendar sind
            if ($(this).closest('.soswi-eventcalendar').length > 0) {
                return; // Eventcalendar handelt seine Filter selbst
            }
            applyAllFilters();
        });

        // Event-Handler für Filter-Suchfeld
        $('#searchFilter').on('input', function() {
            // Prüfe ob wir im Eventcalendar sind
            if ($(this).closest('.soswi-eventcalendar').length > 0) {
                return; // Eventcalendar handelt seine Filter selbst
            }
            applyAllFilters();
        });

        // Spendenformular (FormID 2): "Anderes"-Feld leeren und fokussieren,
        // wenn die "Anderes"-Option ausgewählt wird oder das Input fokussiert wird.
        function clearOtherChoiceDefault($input) {
            if ($input.length && ($input.val() === 'Anderes' || $input.val() === 'Other')) {
                $input.val('');
            }
        }

        $(document).on('focus', '#gform_wrapper_2 .gchoice_other_control', function() {
            clearOtherChoiceDefault($(this));
        });

        $(document).on('change', '#gform_wrapper_2 input[type="radio"]', function() {
            if (this.value !== 'gf_other_choice') {
                return;
            }
            var $other = $('#gform_wrapper_2 .gchoice_other_control');
            clearOtherChoiceDefault($other);
            // Fokus setzen, sobald GF das Input via gformToggleRadioOther aktiviert hat
            setTimeout(function() {
                $other.trigger('focus');
            }, 0);
        });
    });
})(jQuery);